<template>
  <div class="app" :class="`client-${ clientConfig ? clientConfig.id : '' }`" >
    <div class="t-login">
      <div class="t-login__container">
        <div class="t-login__header t-logos">
          <div class="t-logos__item">
            <img :src="logoSrc" style="max-height: 120px"/>
          </div>
          <div class="t-logos__item">
            <vlast-text-icon :fill="brandVlastText" v-if="$vlastMode" />
          </div>
        </div>
        <slot></slot>
      </div>
    </div>

    <div class="footer" v-if="$vlastMode && !$whitelabel">
      <div class="footer__container">
        <div class="footer__row">
          <div class="footer__icon">
            <vlast-logo fill="white"/>
          </div>
          <div class="footer__heading">Unleash your star power.</div>
        </div>
        <div class="footer__row">
          <div class="footer__legal">Copyright&copy; 2020</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LaddaButton from 'codium-ladda-button'
import VlastTextIcon from '../icons/VlastTextIcon'
import VlastLogo from '../icons/VlastLogo'
import { mapState } from 'vuex'
// TODO fix so we dont have to import logos for login each time

export default {
  data () {
    return {
      email: '',
      password: '',
      remember: true
    }
  },

  components: {
    LaddaButton,
    VlastTextIcon,
    VlastLogo
  },

  computed: {
    ...mapState('clientConfig', ['client_config']),
    brandVlastText () {
      return this.client_config.colours.brand_vlast_text
    },
    logoSrc () {
      return this.client_config.tenant_details.path_to_logo
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/sass/mixins/global-mixins";
  @import "../../assets/sass/bootstrap/variables";

  $error: var(--brand-vlast-text);

  .app {
    background-color: var(--brand-vlast);
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    min-height: 100vh;
    & > * {
      width: 100%;
    }
  }

  .t-logos {
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    @media (min-width: 992px) {
      margin-bottom: 2rem;
    }
    &__item {
      height: 8rem;
      width: 8rem;
      display: inline-flex;
      align-items: center;
      svg {
        max-width: 8rem;
        width: 100%;
      }
    }
  }

  .help-block {
    text-align: left;
    color: var(--brand-vlast);
    font-size: $font-size-small;
    background-color: $error;
    padding: 1em;
    position: relative;
    top: 100%;
    margin-top: 1rem;
    border-radius: .25rem;
    left: 0;
    z-index: 1;
    font-weight: 800;
    font-family: "Open Sans", sans-serif;

    &::before {
      content: '';
      border-left: .4rem solid transparent;
      border-right: .4rem solid transparent;
      border-bottom: .4rem solid $error;
      position: absolute;
      top: -.4rem;
    }
  }

  .t-login {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    height: 100%;
    background: var(--brand-vlast);
    flex-grow: 2;
    @media (min-width: 991px) {
      align-items: flex-start;
    }
    @media (min-width: 992px) {
      align-items: center;
    }

    .client-pickstar & {
      background-color: white;
    }

    &__container {
      @include fp(padding-left, 15, 60);
      @include fp(padding-right, 15, 60);
      max-width: 48rem;
      width: 100%;
      display: flex;
      flex-flow: row wrap;
      justify-content: center;
      position: relative;
      overflow: hidden;
      @media (min-width: 991px) {
        align-items: flex-start;
      }
      @media (min-width: 992px) {
        align-items: center;
      }
    }

    &__header {
      width: 100%;
      display: flex;
      align-items: center;
      position: relative;
      z-index: 1;
    }

    &__footer {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      position: relative;
      z-index: 1;
      background-color: black;
      text-align: center;
      padding-top: 50px;
    }

    &__form {
      width: 100%;
      position: relative;
      z-index: 1;
    }

    &__field {
      color: var(--brand-vlast-text);
      position: relative;
      z-index: 0;
    }

    img {
      position: relative;
      /*width: 150px;*/
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      border-radius: 5px;
    }

    h1 {
      text-align: center;
    }

    label {
      font-size: $font-size-small;
      text-transform: uppercase;
      letter-spacing: 0.08em;
      text-align: left;
      margin-top: 20px;
    }

    input {
      font-size: 16px;
      line-height: 1.2;
      height: unset;
      padding: 1em;
      background-color: transparent;
      color: var(--brand-vlast-text);
      border-color: var(--brand-vlast-text);
      border-width: 1px;

      &[aria-invalid] {
        &:focus {
          + .help-block {
            display: none;
          }
        }
      }
    }

    .btn {
      margin: 20px 0px;
      color: var(--brand-text);
      background-color: var(--brand-primary);

      .client-pickstar & {
        background-color: var(--brand-primary);
        color: white
      }
    }

    .reset-link {
      background: none;
      border: none;
      margin-left: 1em;
      background: var(--brand-vlast);
      color: var(--brand-vlast-text);
      box-shadow: none;
      text-decoration: underline;
      &:hover,
      &:active,
      &:focus {
        outline: none;
        text-decoration: none;
      }

      .client-pickstar & {
        color: var(--brand-primary);
        background-color: white
      }
    }
  }

  .footer {
    background-color: $grey-dark;
    color: white;
    padding: 4rem 0;
    flex-wrap: wrap;
    justify-content: center;
    &__icon {
      width: 6rem;
      display: inline-flex;
      align-items: center;
      svg {
        width: 100%;
      }
    }
    &__container {
      margin: 0 auto;
      max-width: 48rem;
      width: 100%;
    }

    &__row {
      width: 100%;
      margin: 0 auto;
      text-align: center;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      &:last-of-type {
        border-top: 1px solid white;
        padding-top: .5rem;
        margin-top: 1rem;
      }
    }
    &__heading {
      font-family: $font-family-base;
      text-transform: uppercase;
      letter-spacing: 0.12em;
      font-size: 21px;
    }
    &__legal {
      font-family: $font-family-base;
      text-transform: uppercase;
      letter-spacing: 0.12em;
      font-size: 11px;
    }
  }

</style>
